<div class="ad-redirection">
  <div class="ad-redirection-inner">
    <div class="ad-redirection-image">
      <img src="./assets/images/rocket.svg" alt="" />
      <div class="rocket-line one"></div>
      <div class="rocket-line two"></div>
      <div class="rocket-line three"></div>
      <div class="rocket-line four"></div>
      <div class="rocket-line five"></div>
    </div>
    <div class="login-heading">Please wait. We are redirecting you to organization's sign in page.</div>
  </div>
</div>
